import { HttpError, httpClient } from '@/shared/api/httpClient';

/**
 * Produtos add-on ("complementos"): recursos vendidos à parte da
 * assinatura — pós-venda, PDV, … O direito de uso é por produto e quem
 * decide é o servidor; o desktop guarda uma cópia assinada para operar
 * offline (por isso `origem: 'sem-conexao'` com `ativo: true` é normal lá).
 *
 * A rota é a mesma nos dois alvos: IPC no desktop, HTTP no web, via
 * `httpClient` → `plataforma.request`.
 */

/** Dados de vitrine do produto, vindos do catálogo do servidor. */
export type ProdutoComplemento = {
  nome: string;
  descricao: string | null;
  precoBRL: number;
  precoOriginalBRL: number | null;
  frequenciaMeses: number;
};

export type EntitlementProduto = {
  codigo: string;
  ativo: boolean;
  validaAte: string | null;
  verificadoEm: string;
  origem: 'servidor' | 'cache' | 'sem-conexao';
  produto: ProdutoComplemento | null;
};

/** Página de compra do produto no site — abre fora do app nos dois alvos. */
export function urlAssinaturaProduto(codigo: string): string {
  return `https://oficinaagil.softjack.com.br/assinar/produto/${encodeURIComponent(codigo)}`;
}

/**
 * O erro veio de uma rota travada porque o produto não está liberado?
 * As rotas de cada produto respondem `<codigo>.inativo` (sem direito) ou
 * `<codigo>.sem_conexao` (desktop offline sem cópia válida).
 */
export function ehErroProdutoBloqueado(erro: unknown, codigo: string): boolean {
  if (!(erro instanceof HttpError)) return false;
  const codigoErro = erro.payload?.codigo;
  return codigoErro === `${codigo}.inativo` || codigoErro === `${codigo}.sem_conexao`;
}

export const complementosApi = {
  /** Direito de uso do produto. `forcar` pede ao backend que ignore o cache. */
  entitlement: (codigo: string, forcar = false) =>
    httpClient.get<EntitlementProduto>(
      `/api/produtos/${encodeURIComponent(codigo)}/entitlement${forcar ? '?forcar=true' : ''}`,
    ),
};
